
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import CompetenciesContent from "./Components/CompetenciesContent.vue";

export default defineComponent({
  name: "CompetenciesView",
  components: {
    BreadCrumb,
    CompetenciesContent,
  },
});
